import "../style.scss";
import header from "../../../assets/images/logo_one.svg";
import facebookIcon from "../../../assets/images/Facebook.svg";
import linkedinIcon from "../../../assets/images/Linkedin.svg";
import twitterIcon from "../../../assets/images/Twitter.svg";
import gmailIcon from "../../../assets/images/Gmail.svg";
import footerImage from "../../../assets/images/footer_img.svg";
import backgroundImage from "../../../assets/images/Login .png";
import { useEffect, useState } from 'react';
import HP from "../../../host";
import axios from "axios";
import { useAppDispatch } from "../../../hooks/app";
import { loginUser } from "../../../store/slices/auth-slice";
import { Link, useNavigate } from "react-router-dom";
import useCustomToast from "../../../hooks/useCustomToast";
import UserService from "../../../services/user.service";
import { Toaster } from "react-hot-toast";

function ForgetPassword() {
    const dispatch = useAppDispatch()

    const customToast = useCustomToast()
    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        username: '',
    });


    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        const { username } = formData;
        const response: any = await UserService.forgetPassword({ username: username })
        if (response?.success) {
            customToast(response?.success, "success")
        }
    };

    return (
        <div className="auth__page">
            <Toaster />
            <div className="row h-100">
                <div className="col-lg-4 col-md-12 p-0">
                    <div className="left">
                        <img src={header} className="login_logo" alt="Pilot Book" />
                        <form>
                            <h2 className="welcome heading2">Forget Password</h2>
                            <h4 className="login_subheading heading4">
                                Enter username or email to reset your password
                            </h4>
                            <input
                                className="input"
                                type="text"
                                placeholder="Enter Your Username"
                                name="username"
                                value={formData.username}
                                onChange={handleChange}
                                required
                            />
                            <button className="login_btn" onClick={handleSubmit}>Reset Password</button>
                        </form>
                        <h4 className="signup_now heading4">
                            Don't have an account ?{" "}
                            <Link to="/register">
                                <span style={{ textDecoration: "underline", color: "#232629" }}>
                                    Signup now
                                </span>
                            </Link>
                        </h4>
                        <h4 className="forget_pass heading4">Forgot Password</h4>
                        <img src={footerImage} className="footer_img" alt="LandScape" />
                        <h4 className="copyright heading4">© 2023 Pilots Logbook</h4>
                    </div>
                </div>
                <div className="col-lg-8 d-none d-md-block h-auto p-0">
                    <div className="background">
                        <img src={backgroundImage} className="login_bg" alt="Login Background" />
                        <div className="content">
                            <h4 className="login_bg_heading">
                                The most complete digital pilot logbook
                            </h4>
                            <h4 className="login_bg_subheading">
                                Pilots Logbook makes your life easier through its super fast flight
                                logging, detailed analysis of your flight time with the Analyze view,
                                the powerful InSight technology that monitors all your upcoming flights
                                and warns you of any rest / duty / currency issues, with all your
                                irreplaceable flying life backed up to your choice of iCloud, Dropbox,
                                or both!
                            </h4>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
}

export default ForgetPassword;